import { render } from "./ChooseImage.vue?vue&type=template&id=b083df14&scoped=true"
import script from "./ChooseImage.vue?vue&type=script&lang=js"
export * from "./ChooseImage.vue?vue&type=script&lang=js"

import "./ChooseImage.vue?vue&type=style&index=0&id=b083df14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b083df14"

export default script